/**
 * Which design this browser is editing.
 *
 * One short string, and it lives here rather than inside the editor because two
 * unrelated places need it: the editor sets it when it opens something, and the
 * Designs list has to clear it when you delete whatever it points at. Without
 * that second half, deleting the design you had open leaves the pointer aimed
 * at an id with nothing behind it — the next visit opens a blank editor under
 * the dead id, and the first brush stroke writes the design back, titled and
 * all. A delete that undoes itself a minute later is worse than one that fails.
 *
 * `localStorage`, not IndexedDB: it has to be readable synchronously during
 * boot to decide whether to restore, and losing it costs nothing — the designs
 * are still in IndexedDB and still listed on `/app/projects`.
 */
const CURRENT_KEY = "rcm:current-project";

export function currentProjectId(): string | null {
  try {
    return localStorage.getItem(CURRENT_KEY);
  } catch {
    // Storage blocked. Callers fall back to the most recent design.
    return null;
  }
}

export function setCurrentProjectId(id: string) {
  try {
    localStorage.setItem(CURRENT_KEY, id);
  } catch {}
}

/**
 * Stop pointing at a design.
 *
 * Takes the id it expects to be forgetting so that deleting some *other* design
 * cannot clear the pointer to the one you are editing.
 */
export function forgetProjectId(id: string) {
  try {
    if (localStorage.getItem(CURRENT_KEY) === id) localStorage.removeItem(CURRENT_KEY);
  } catch {}
}
